import { render, staticRenderFns } from "./EventTemplatesDashboard.vue?vue&type=template&id=3a02300f"
import script from "./EventTemplatesDashboard.vue?vue&type=script&lang=js"
export * from "./EventTemplatesDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports